module.exports = __webpack_public_path__ + "media/images/plans/plan-icon-accessories-3b326aa50f459a92a6ca5ec6719f5cfa.png";